import CustomInput from '@components/CustomInput';
import Grid from '@mui/material/Grid';
import fieldRequiredProps from '@utils/formik/fieldRequiredProps';
import { FieldProps } from 'formik';
import { FC } from 'react';
import { IFormValues, validationSchema } from '../../constants/formik';

const SwitchTextOff: FC<FieldProps<IFormValues>> = ({ form }) => (
  <>
    {form.values.switchTextOff !== undefined ? (
      form.values.switchTextOff !== null ? (
        <Grid item>
          <CustomInput
            {...fieldRequiredProps(form, validationSchema, 'switchTextOff')}
            label="OFF text"
            clearFieldIcon={true}
          />
        </Grid>
      ) : null
    ) : form.initialValues.switchTextOff !== null ? (
      <Grid item>
        <CustomInput
          {...fieldRequiredProps(form, validationSchema, 'switchTextOff')}
          label="OFF text"
          clearFieldIcon={true}
        />
      </Grid>
    ) : null}
  </>
);

export default SwitchTextOff;
